#import "../CorporateWorkgroupsFields.graphql"
mutation CorporateWorkgroupCreate($input: CorporateWorkgroupCreateInput!) {
  corporateWorkgroupCreate(input: $input) {
    corporateWorkgroup {
      ...CorporateWorkgroupsFields
      prefixCode
    }
  }
}
